import type {VatKz, VatLine, VatReturn, VatReturnStatus} from '@vat/engine/types';

/**
 * Typ-Schicht der Exporte (Spec 7). Definiert KEINEN Spec-Typ neu – `VatReturn`/`VatReturnStatus`
 * werden aus dem Rechenkern re-exportiert; dies ist die einzige Stelle mit diesem Import-Pfad (A0).
 *
 * @author Anthony Nahas
 * @since 11.09.26
 */
export type {VatReturn, VatReturnStatus};

export type VatReturnExport = VatReturn['exports'][number];
export type VatExportType = VatReturnExport['type'];
export type VatReturnAdjustment = VatReturn['adjustments'][number];
export type VatReturnChecklistEntry = VatReturn['checklist'][string];

/** Anzeige-Label einer Immobilie („H12 · Musterstraße 1, 80331 München“), aus Stammdaten aufgelöst. */
export interface VatExportPropertyLabel {
    id: string;
    label: string;
}

export interface VatExportLandlord {
    name: string;
    addressLine: string;
}

/** Freigabe-Snapshot plus Stammdaten-Labels – die einzige Eingabe aller reinen Builder (nie Live-Daten). */
export interface VatExportSnapshot {
    vatReturn: VatReturn;
    lines: VatLine[];
    landlord: VatExportLandlord;
    properties: VatExportPropertyLabel[];
    now: Date;
}

export type VatExportReportID = 'vordruck-pdf' | 'herleitung-excel' | 'kz48-pdf' | 'objekt-abrechnung' | 'elster-xml' | 'datev';
/** Objekt-Abrechnung ist der einzige formatabhängige Bericht (PDF oder Excel, Task C2). */
export type VatExportAction = 'VORDRUCK_PDF' | 'HERLEITUNG_EXCEL' | 'KZ48_PDF' | 'OBJEKT_PDF' | 'OBJEKT_EXCEL';
export type VatObjektExportFormat = 'pdf' | 'excel';

/** Reihenfolge der Kennzahlen in Anlage A und in den Excel-Blättern. */
export const VAT_EXPORT_KZ_ORDER: VatKz[] = ['81', '86', '48', '66'];
